import React, { useState } from "react";
import PayButton from "../components/PayButton";
import "./PayScreen.css";
import { useNavigate } from "react-router-dom";
import eclipse from "../assets/splash-eclipse.png";
import cashier from "../assets/cashier.png";
import CashRegisterDrop from "../components/CashRegisterDrop";
import DraggableCoin from "../components/DraggableCoin";
import CoinBasket from "../components/CoinBasket";

// Dummy coin images – use your actual images here
import coin1 from "../assets/coin-1.png";
import coin2 from "../assets/coin-2.png";
import coin5 from "../assets/coin-5.png";
import coin10 from "../assets/coin-10.png";

const coins = [
  { name: "1€", value: 1, image: coin1 },
  { name: "2€", value: 2, image: coin2 },
  { name: "5€", value: 5, image: coin5 },
  { name: "10€", value: 10, image: coin10 },
];

function speak(text) {
  if ("speechSynthesis" in window) {
    const utterance = new SpeechSynthesisUtterance(text);
    window.speechSynthesis.speak(utterance);
  }
}

const PayScreen = () => {
  // Tracks counts of each coin value
  const [basket, setBasket] = useState({});
  const navigate = useNavigate();

  // Unified function to add a coin (clicked or dropped)
  const addToBasket = (coinValue) => {
    speak(`Added ${coinValue} euro`);
    setBasket((prev) => ({
      ...prev,
      [coinValue]: (prev[coinValue] || 0) + 1,
    }));
  };

  // Remove one coin of given value
  const handleRemoveCoin = (value) => {
    speak(`Removed ${value} euro`);
    setBasket((prev) => {
      const updated = { ...prev };
      if (updated[value] > 1) {
        updated[value]--;
      } else {
        delete updated[value];
      }
      return updated;
    });
  };

  // Recompute moneyInserted from basket for payment validation
  const moneyInserted = Object.entries(basket).flatMap(([val, count]) =>
    Array(count).fill(Number(val))
  );

  const handlePayment = () => {
    const totalInserted = moneyInserted.reduce((sum, val) => sum + val, 0);
    if (totalInserted >= 7) {
      alert("Payment successful!");
      navigate("/success");
    } else {
      alert(`Please insert at least 7€ (You inserted ${totalInserted}€)`);
    }
  };

  const handleBack = () => {
    navigate("/level1");
  };

  return (
    <div className="level-one-container" style={{ position: "relative" }}>
      <img src={eclipse} alt="Background shape" className="levelone-eclipse" />

      <button onClick={handleBack} className="back-button">
        ← Back
      </button>

      <h3 className="task-message">Your total is 7€</h3>
      <p className="task-instructions">Drag and drop your money in to pay</p>

      <div style={{ textAlign: "center" }}>
        <img src={cashier} alt="Cashier" style={{ maxWidth: "180px" }} />
      </div>

      {/* Coins you can drag or click to add */}
      <div className="fruit-stand">
        {coins.map((coin) => (
          <DraggableCoin key={coin.value} coin={coin} onClick={addToBasket} />
        ))}
      </div>

      <div className="basket-pay-wrapper" style={{ display: "flex", gap: "20px", alignItems: "center" }}>
        {/* Shows coins added and allows removing */}
        <CoinBasket basket={basket} onRemove={handleRemoveCoin} />

        {/* Drop target area */}
        <CashRegisterDrop moneyInserted={moneyInserted} onDropMoney={addToBasket} />

        <button className="pay-button" onClick={handlePayment}>
          Pay
        </button>
      </div>
    </div>
  );
};

export default PayScreen;
